import { Col, Container, ProgressBar, Row } from 'react-bootstrap';
import usePublicForm from '../../hooks/publicForm.hook';
import CustomerRegisterForm from './CustomerRegisterForm';
import EndForm from './EndForm';
import MainForm from './MainForm';
import ValidateForm from './ValidateForm';
import './index.scss';

// TODO: Que el loading se maneje a este nivel y se infiera para todos los hijos
const PublicForm = () => {
  const { step } = usePublicForm();

  const getCurrentStepView = () => {
    switch (step) {
      case 1:
        return <ValidateForm />;
      case 2:
        return <CustomerRegisterForm />;
      case 3:
        return <MainForm />;
      default:
        return <EndForm />;
    }
  };

  const progressBar = (step - 1) * 34;

  return (
    <Container fluid>
      <Row className="d-flex justify-content-center pt-4 form-page">
        <Col sm={12} className="form-container mb-5">
          <ProgressBar className="mb-3" now={progressBar} />
          {getCurrentStepView()}
        </Col>
      </Row>
    </Container>
  );
};

export default PublicForm;
